export const liveCitiesSearch = async (query) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/cities/dropdown?query=${query}`,
      { cache: 'no-store' }
    )
    if (!res.ok) {
      return []
    }
    const result = await res.json()
    return result.data || []  // ✅ return only the data array
  } catch (error) {
    return []
  }
}

export const dialCodes = async () => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/dial-codes/dropdown`,
    )
    if (!res.ok) {
      return []
    }
    const result = await res.json()
    return result.data || []  // ✅ return only the data array
  } catch (error) {
    return []
  }
}